<template>
  <div class="subMenu">
    <ul>
      <template v-for="(data, index) in dataSource">
        <el-badge :value="(data.num&&data.num) > 0 ? data.num : ''" :key="index">
          <li
            class="item text-center fs-14 cursor-pointer"
            :class="{ active: index == currentIndex }"
            @click="handleClick(index)"
          >
            {{data.label}}
          </li>
        </el-badge>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  name: "subMenu",
  props: {
    dataSource: {
      type: Array,
      default: function() {
        return [
          {
            label: "tab1",
            value: 0,
          },
          {
            label: "tab2",
            value: 0
          }
        ];
      }
    },
    subMenuIndex:{
      type:Number,
      default:0
    }
  },
  data(){
    return {
       currentIndex:this.subMenuIndex || 0
    }
  },
  watch:{
     subMenuIndex(){
        this.currentIndex = this.subMenuIndex;
     }
  },
  methods: {
    handleClick(index) {
      this.currentIndex = index;
      this.$emit("update:subMenuIndex",index);
      this.$emit("click", this.currentIndex);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../sass/mixins.scss";

.subMenu {
  // background-color: $--color-gray;
  /deep/ .el-badge__content.is-fixed{
    top: 10px;
    right: 19px;
    background: $--color-primary;
  }
  .item {
    display: inline-block;
    padding: 15px 0;
    margin: 0 15px;
    color: $--color-text-gray;
    &:hover {
      color: $--color-primary;
    }
  }
  .item.active {
    position: relative;
    border-bottom: 2px solid $--color-primary;
    color: $--color-primary;
    &::before {
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      @include triangle(
        $direction: top,
        $size: 6px,
        $borderColor: $--color-primary
      );
    }
  }
}
</style>